import theme from "../../../../js/shared/new-theme";

export const rankingOffersStyle = `
  font-size: 12px;
`;
export const itemRankingOffersRowsStyle = userOffer => `
  display: flex;
  box-sizing: content-box;
  flex-direction: row;
  height: 25px;
  margin-bottom: 5px;
  border: ${userOffer ? `1px solid ${theme.palette.gray[400].value}` : "0"};
  border-radius: ${userOffer ? "4" : "0"}px;
`;

export const itemRankingOffersPositionStyle = flex => `
  display: flex;
  flex: ${flex};
  align-items: center;
  justify-content: center;
  background-color: ${theme.palette.common.white};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const itemRankingOffersCurrencyStyle = flex => `
  display: flex;
  flex: ${flex};
  align-items: center;
  background-color: ${theme.palette.common.white};
`;

export const itemRankingOffersActiveStyle = flex => `
  display: flex;
  flex: ${flex};
  align-items: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  justify-content: space-between;
  background-color: ${theme.palette.common.white};
  font-weight: bold;
`;

export const itemRankingOffersUserStyle = flex => `
  display: flex;
  flex: ${flex};
  align-items: center;
  justify-content: center;
  margin-left: 1px;
  background-color: ${theme.palette.gray[300].value};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const itemRankingOffersTextPosition = `
`;

export const itemRankingOffersTextCurrency = `
  padding-left: 12px;
  color: ${theme.palette.gray[800].value};
`;

export const itemRankingOffersTextUser = `
  padding-right: 12px;
  color: ${theme.palette.gray[800].value};
`;

export const info = `
  padding-bottom: 36px;
  margin: 16px 0;
`;
